import { api } from './api.js';

export const COMPANY_CAMPAIGN_IDENTITY_RECOVERY_MESSAGE =
  'We couldn\'t initialize this company\'s campaign profile. Refresh and try again, or contact support.';

function tenantHeaders(companyId) {
  return companyId ? { headers: { 'x-company-id': companyId } } : undefined;
}

export function isActiveCompanyBrand(brand, companyId = '') {
  return Boolean(
    brand?.id
      && (!companyId || brand.companyId === companyId)
      && String(brand.status || '').toLowerCase() === 'active'
      && !brand.deletedAt,
  );
}

export async function ensureAndLoadCompanyBrands({
  requestApi = api,
  companyId,
} = {}) {
  await requestApi.post(
    '/api/saas/company/campaign-identity/ensure',
    {},
    tenantHeaders(companyId),
  );
  const response = await requestApi.get('/api/saas/brands', tenantHeaders(companyId));
  return {
    ...response,
    brands: (Array.isArray(response?.brands) ? response.brands : [])
      .filter((brand) => isActiveCompanyBrand(brand, companyId)),
  };
}
